import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-asset-details-box',
  templateUrl: './asset-details-box.component.html',
  styleUrls: ['./asset-details-box.component.scss'],
  standalone:true
})
export class AssetDetailsBoxComponent implements OnInit {

  @Input('company_name') company_name:string='';
  @Input('app_name') application:string='';
  @Input('site_name') site:string='';
  @Input('asset_name') asset_name:string='';
  @Input('product_type') product_type:string='powertrain';


  constructor() { }

  ngOnInit(): void {
    console.log(this.asset_name, this.company_name, this.site, this.application);
  }

}
